import companies from 'modules/core/store/collections/companies'

import type { IncidenceQueryData } from 'modules/bookkeepers/hooks/useGetIncidences'

const useCurrentIncidenceCompany = (incidence: IncidenceQueryData) => {
  const companyId = incidence.legalEntity?.companyId
  const company = companies.find({ id: companyId })

  if (!company) {
    throw Error(`Error finding company with id = ${companyId}`)
  }

  return company
}

export default useCurrentIncidenceCompany
